export default __webpack_public_path__ + "static/media/cover_4.8589ada7.jpg";